"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightAlign = exports.RightAlignTD = exports.FullColumn = exports.SmallColumn = exports.RightColumn = exports.LeftColumn = exports.Column = void 0;
var React = require("react");
var typestyle_1 = require("typestyle");
var Column = function (props) { return React.createElement("div", { className: "Column" }, props.children); };
exports.Column = Column;
var LeftColumn = function (props) { return React.createElement("div", { className: "Column Column--left" }, props.children); };
exports.LeftColumn = LeftColumn;
var RightColumn = function (props) { return React.createElement("div", { className: "Column Column--right" }, props.children); };
exports.RightColumn = RightColumn;
var SmallColumn = function (props) { return React.createElement("div", { className: "Column Column--small" }, props.children); };
exports.SmallColumn = SmallColumn;
var FullColumn = function (props) { return React.createElement("div", { className: "Column Column--fullwidth" }, props.children); };
exports.FullColumn = FullColumn;
var RightAlignTD = function (props) { return React.createElement("td", { className: (0, typestyle_1.style)({ textAlign: "right" }) }, props.children); };
exports.RightAlignTD = RightAlignTD;
var RightAlign = function (props) { return React.createElement("div", { className: (0, typestyle_1.style)({ textAlign: "right" }) }, props.children); };
exports.RightAlign = RightAlign;
